export const companyInfo = {
  name: 'Hakimi Control Systems',
  tagline: 'Reliable Power. Intelligent Control. Industrial Excellence.',
  description: 'Specializes in the design and manufacturing of customized electrical control panels with complete end-to-end solutions. Committed to delivering high-quality panels, cost-efficient engineering, on-time delivery, and reliable post-installation support, ensuring long-term operational excellence.',
  founder: 'Ali Asger Sir',
  phone: '+91 7742437253',
  email: 'HakimiPowerControlSystems@gmail.com',
  address: 'Near New Jamnagar Battery, C/O, Gondal Chowkdi, Vavdi, Rajkot, Gujarat 360004',
  instagram: 'https://www.instagram.com/hakimipowercontrolsystems',
  heroImage: 'https://images.unsplash.com/photo-1513828583688-c52646db42da?w=1600&h=900&fit=crop',
  ctaImage: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=1600&h=900&fit=crop',
  refineryImage: 'https://images.unsplash.com/photo-1513828583688-c52646db42da?w=1600&h=900&fit=crop'
  // heroImage: 'https://customer-assets.emergentagent.com/job_ab920cfc-e5f9-4d63-816a-994528cb5042/artifacts/fl8vtmud_factory-night-view-7806641_1280.jpg',
  // ctaImage: 'https://customer-assets.emergentagent.com/job_ab920cfc-e5f9-4d63-816a-994528cb5042/artifacts/36ga8lvz_plant-7806635_1280.jpg',
  // refineryImage: 'https://customer-assets.emergentagent.com/job_ab920cfc-e5f9-4d63-816a-994528cb5042/artifacts
};

export const products = [
  {
    id: 1,
    name: 'MCC Panels',
    shortDesc: 'Motor Control Center panels for comprehensive motor management',
    description: 'Fully Draw-out / Non Draw-out configurations with compartmentalized or non-compartmentalized designs.',
    features: [
      'Fully Draw-out / Non Draw-out',
      'Compartmentalized / Non-Compartmentalized',
      'Single Front / Double Front Operation',
      'Equipped with ACB, MCCB, MCB, SFU, RTU',
      'DOL, ATS & Star-Delta starters',
      'Manual & Automatic motor control systems'
    ],
    image: 'https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop'
  },
  {
    id: 2,
    name: 'PCC Panels',
    shortDesc: 'Power Control Center panels for industrial power distribution',
    description: 'High-capacity power distribution panels designed for industrial, commercial & utility applications.',
    features: [
      'Current ratings from 800A to 6300A',
      'Single Front & Double Front designs',
      'Fixed & Draw-out configurations',
      'Fully compartmentalized construction',
      'IEC 61439 compliant',
      'Designed for industrial, commercial & utility power distribution'
    ],
    image: 'https://images.pexels.com/photos/2760243/pexels-photo-2760243.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop'
  },
  {
    id: 3,
    name: 'Soft Starter Panels',
    shortDesc: 'Advanced motor starting solutions with reduced mechanical stress',
    description: 'Intelligent motor control panels for smooth starting and stopping operations.',
    features: [
      'Equipped with MCCB, Bypass Contactor & Soft Starter',
      'Smooth motor starting & stopping',
      'Reduced mechanical stress and inrush current',
      'Built-in protections: Overload, Overcurrent, Under / Over Voltage',
      'Graphical display & logical keypad for monitoring'
    ],
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&h=600&fit=crop'
  },
  {
    id: 4,
    name: 'VFD Panels',
    shortDesc: 'Variable Frequency Drive panels for precise motor speed control',
    description: 'Advanced VFD solutions with backup operation capabilities for uninterrupted plant operations.',
    features: [
      'Precise motor speed control',
      'MCCB, Bypass Contactor, I/O Chokes',
      'Speed control potentiometer',
      'Special feature: DOL / Star-Delta backup operation during VFD failure',
      'Ensures uninterrupted plant operation'
    ],
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop'
  },
  {
    id: 5,
    name: 'PLC Automation Panels',
    shortDesc: 'Programmable Logic Controller panels for industrial automation and process control',
    description: 'Custom-built PLC automation panels designed for machine control, process automation, and seamless plant operations with intelligent monitoring and control systems.',
    features: [
      'PLC-based machine and process automation',
      'HMI integration for operator control and monitoring',
      'VFD, MCCB, Relays, Contactors, and SMPS integration',
      'Supports motors, pumps, conveyors, compressors, and HVAC systems',
      'Custom programming, commissioning, and AMC support'
    ],
    image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=800&h=600&fit=crop'
  },
  {
    id: 6,
    name: 'Fire Safety Panels',
    shortDesc: 'Fire detection and emergency safety control panels for buildings and industries',
    description: 'Reliable fire safety panel solutions for fire detection, alarm management, pump control, and emergency response systems with compliance-focused design.',
    features: [
      'Fire Alarm Control Panel (FACP) integration',
      'Smoke detectors, heat detectors, and manual call points support',
      'Hooters, sirens, strobe lights, and emergency alert systems',
      'Fire pump control and sprinkler monitoring',
      'Battery backup and emergency shutdown integration'
    ],
    image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&h=600&fit=crop'
  }
];

export const services = [
  {
    id: 1,
    title: 'Industrial Standard Panel Design',
    description: 'Custom-engineered control panels designed to meet international standards and your specific requirements.'
  },
  {
    id: 2,
    title: 'Precision Panel Manufacturing',
    description: 'State-of-the-art manufacturing facilities ensuring highest quality and precision in every panel.'
  },
  {
    id: 3,
    title: 'Customized Engineering Solutions',
    description: 'Tailored solutions to meet your unique industrial control and automation needs.'
  },
  {
    id: 4,
    title: 'Post-Delivery Maintenance Support',
    description: 'Comprehensive after-sales support to ensure long-term operational excellence.'
  },
  {
    id: 5,
    title: 'Panel Health Monitoring',
    description: 'Proactive monitoring services to prevent downtime and ensure optimal performance.'
  },
  {
    id: 6,
    title: 'Scheduled Panel Cleaning Services',
    description: 'Regular maintenance and cleaning services to extend panel life and maintain efficiency.'
  }
];

export const caseStudies = [
  {
    id: 1,
    title: 'Manufacturing Plant Automation',
    client: 'Industrial Manufacturing Co.',
    description: 'Complete automation solution with MCC and VFD panels for a large-scale manufacturing facility.',
    industry: 'Manufacturing',
    image: 'https://images.unsplash.com/photo-1581092795360-fd1ca04f0952?w=800&h=600&fit=crop'
  },
  {
    id: 2,
    title: 'Power Distribution Upgrade',
    client: 'Commercial Complex Ltd.',
    description: 'High-capacity PCC panel installation for efficient power distribution across multiple buildings.',
    industry: 'Commercial',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&h=600&fit=crop'
  },
  {
    id: 3,
    title: 'Motor Control System',
    client: 'Processing Industries Inc.',
    description: 'Soft starter and VFD integration for precise motor control in processing operations.',
    industry: 'Industrial',
    image: 'https://images.unsplash.com/photo-1581092162384-8987c1d64718?w=800&h=600&fit=crop'
  }
];

export const projectTypes = [
  { value: 'industrial', label: 'Industrial' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'residential', label: 'Residential' },
  { value: 'custom', label: 'Custom Solution' }
];

export const galleryImages = [
  { src: '/gallery/panel-01.jpeg', title: 'MCC Panel Assembly', specs: { type: 'Motor Control Center (MCC)', voltage: '415V / 3-Phase', current: 'Up to 800A', ip_rating: 'IP54', standard: 'IEC 61439' } },
  { src: '/gallery/panel-02.jpeg', title: 'Draw-out MCC Panel', specs: { type: 'MCC – Fully Draw-out', voltage: '415V / 3-Phase', current: 'Up to 630A', ip_rating: 'IP42', standard: 'IEC 61439' } },
  { src: '/gallery/panel-03.jpeg', title: 'Compartmentalized MCC', specs: { type: 'MCC – Compartmentalized', voltage: '415V / 3-Phase', current: 'Up to 1000A', ip_rating: 'IP55', standard: 'IEC 61439' } },
  { src: '/gallery/panel-04.jpeg', title: 'PCC Power Distribution Panel', specs: { type: 'Power Control Center (PCC)', voltage: '415V / 3-Phase', current: 'Up to 3200A', ip_rating: 'IP52', standard: 'IEC 61439' } },
  { src: '/gallery/panel-05.jpeg', title: 'High-Capacity PCC Panel', specs: { type: 'Power Control Center (PCC)', voltage: '415V / 3-Phase', current: 'Up to 6300A', ip_rating: 'IP54', standard: 'IEC 61439' } },
  { src: '/gallery/panel-06.jpeg', title: 'VFD Drive Panel', specs: { type: 'Variable Frequency Drive Panel', voltage: '415V / 3-Phase', current: 'Up to 400A', ip_rating: 'IP54', standard: 'IEC 61800' } },
  { src: '/gallery/panel-07.jpeg', title: 'VFD with DOL Backup', specs: { type: 'VFD – DOL/Star-Delta Backup', voltage: '415V / 3-Phase', current: 'Up to 200A', ip_rating: 'IP42', standard: 'IEC 61800' } },
  { src: '/gallery/panel-08.jpeg', title: 'Soft Starter Control Panel', specs: { type: 'Soft Starter Panel', voltage: '415V / 3-Phase', current: 'Up to 630A', ip_rating: 'IP54', standard: 'IEC 60947' } },
  { src: '/gallery/panel-09.jpeg', title: 'Soft Starter with Bypass', specs: { type: 'Soft Starter – Bypass Contactor', voltage: '415V / 3-Phase', current: 'Up to 400A', ip_rating: 'IP55', standard: 'IEC 60947' } },
  { src: '/gallery/panel-10.jpeg', title: 'PLC Automation Panel', specs: { type: 'PLC Automation Panel', voltage: '24V DC / 415V AC', current: 'Up to 100A', ip_rating: 'IP54', standard: 'IEC 61131' } },
  { src: '/gallery/panel-11.jpeg', title: 'PLC with HMI Integration', specs: { type: 'PLC Panel – HMI Integrated', voltage: '24V DC / 415V AC', current: 'Up to 160A', ip_rating: 'IP54', standard: 'IEC 61131' } },
  { src: '/gallery/panel-12.jpeg', title: 'Fire Safety Control Panel', specs: { type: 'Fire Safety Panel (FACP)', voltage: '230V AC / 24V DC', current: 'Up to 20A', ip_rating: 'IP42', standard: 'IS 2189' } },
  { src: '/gallery/panel-13.jpeg', title: 'Fire Pump Control Panel', specs: { type: 'Fire Pump Control Panel', voltage: '415V / 3-Phase', current: 'Up to 100A', ip_rating: 'IP55', standard: 'NFPA 20 / IS 15522' } },
  { src: '/gallery/panel-14.jpeg', title: 'DOL Starter Panel', specs: { type: 'Direct-On-Line (DOL) Starter', voltage: '415V / 3-Phase', current: 'Up to 63A', ip_rating: 'IP42', standard: 'IEC 60947' } },
  // { src: '/gallery/panel-15.jpeg', title: 'Star-Delta Starter Panel', specs: { type: 'Star-Delta Starter Panel', voltage: '415V / 3-Phase', current: 'Up to 200A', ip_rating: 'IP54', standard: 'IEC 60947' } },
  // { src: '/gallery/panel-16.jpeg', title: 'APFC Panel', specs: { type: 'Auto Power Factor Correction', voltage: '415V / 3-Phase', current: 'Up to 800A', ip_rating: 'IP42', standard: 'IEC 61439' } },
  // { src: '/gallery/panel-17.jpeg', title: 'APFC with Capacitor Bank', specs: { type: 'APFC – Capacitor Bank Panel', voltage: '415V / 3-Phase', current: 'Up to 400A', ip_rating: 'IP54', standard: 'IEC 61439' } },
  // { src: '/gallery/panel-18.jpeg', title: 'LT Distribution Panel', specs: { type: 'LT Distribution Board (LDB)', voltage: '415V / 3-Phase', current: 'Up to 1600A', ip_rating: 'IP52', standard: 'IEC 61439' } },
  // { src: '/gallery/panel-19.jpeg', title: 'Main LT Panel', specs: { type: 'Main LT Switchboard', voltage: '415V / 3-Phase', current: 'Up to 4000A', ip_rating: 'IP54', standard: 'IEC 61439' } },
  // { src: '/gallery/panel-20.jpeg', title: 'ATS Panel', specs: { type: 'Automatic Transfer Switch (ATS)', voltage: '415V / 3-Phase', current: 'Up to 1600A', ip_rating: 'IP54', standard: 'IEC 60947' } },
  // { src: '/gallery/panel-21.jpeg', title: 'AMF Panel', specs: { type: 'Auto Mains Failure (AMF)', voltage: '415V / 3-Phase', current: 'Up to 2500A', ip_rating: 'IP55', standard: 'IEC 60947' } },
  // { src: '/gallery/panel-22.jpeg', title: 'Control Desk Panel', specs: { type: 'Operator Control Desk', voltage: '24V DC / 230V AC', current: 'Up to 32A', ip_rating: 'IP42', standard: 'IEC 61439' } },
  // { src: '/gallery/panel-23.jpeg', title: 'SCADA Interface Panel', specs: { type: 'SCADA / Remote I/O Panel', voltage: '24V DC', current: 'Up to 16A', ip_rating: 'IP54', standard: 'IEC 61131' } },
  // { src: '/gallery/panel-24.jpeg', title: 'Conveyor Control Panel', specs: { type: 'Conveyor Automation Panel', voltage: '415V / 3-Phase', current: 'Up to 125A', ip_rating: 'IP54', standard: 'IEC 60204' } },
  // { src: '/gallery/panel-25.jpeg', title: 'HVAC Control Panel', specs: { type: 'HVAC Automation Panel', voltage: '415V / 3-Phase', current: 'Up to 160A', ip_rating: 'IP42', standard: 'IEC 60204' } },
  // { src: '/gallery/panel-26.jpeg', title: 'Pump Control Panel', specs: { type: 'Pump Control Panel', voltage: '415V / 3-Phase', current: 'Up to 200A', ip_rating: 'IP55', standard: 'IEC 60947' } },
  // { src: '/gallery/panel-27.jpeg', title: 'Water Treatment Panel', specs: { type: 'Water Treatment Automation', voltage: '415V / 3-Phase', current: 'Up to 250A', ip_rating: 'IP65', standard: 'IEC 61439' } },
  // { src: '/gallery/panel-28.jpeg', title: 'Compressor Control Panel', specs: { type: 'Compressor Control Panel', voltage: '415V / 3-Phase', current: 'Up to 315A', ip_rating: 'IP54', standard: 'IEC 60947' } },
  // { src: '/gallery/panel-29.jpeg', title: 'Crane & Hoist Panel', specs: { type: 'Crane / Hoist Control Panel', voltage: '415V / 3-Phase', current: 'Up to 100A', ip_rating: 'IP55', standard: 'IEC 60204' } },
  // { src: '/gallery/panel-30.jpeg', title: 'Energy Metering Panel', specs: { type: 'Energy Monitoring Panel', voltage: '415V / 3-Phase', current: 'Up to 1000A', ip_rating: 'IP42', standard: 'IEC 62053' } },
  // { src: '/gallery/panel-31.jpeg', title: 'Feeder Pillar Panel', specs: { type: 'Outdoor Feeder Pillar', voltage: '415V / 3-Phase', current: 'Up to 800A', ip_rating: 'IP65', standard: 'IEC 61439' } },
  // { src: '/gallery/panel-32.jpeg', title: 'Bus Duct Termination Panel', specs: { type: 'Bus Duct Tap-off Panel', voltage: '415V / 3-Phase', current: 'Up to 2000A', ip_rating: 'IP54', standard: 'IEC 61439' } },
  // { src: '/gallery/panel-33.jpeg', title: 'Custom Industrial Panel', specs: { type: 'Custom Engineered Panel', voltage: '415V / 3-Phase', current: 'As per spec', ip_rating: 'IP54', standard: 'IEC 61439' } },
];